import React from 'react';
import { Box, Divider } from '@mui/material';
import type { Header } from '@tanstack/react-table';
import type { FilterOperators, FilterMenuAnchor } from '../types';
import { getOperatorPlaceholder } from '../utils';
import { filterInputBaseStyle } from './filterInputStyles';
import { filterCellBoxSx, filterDividerSx, filterNativeInputStyle } from './filterLayoutStyles';
import { OperatorIconButton } from './OperatorIconButton';

type NumberFilterInputProps<T> = {
  header: Header<T, unknown>;
  filterValue: string;
  filterOperators: FilterOperators;
  setFilterMenuAnchor: React.Dispatch<React.SetStateAction<FilterMenuAnchor>>;
};

/**
 * Number filter input component with operator selection
 * Supports: =, <>, <, >, <=, >=, between
 */
const NumberFilterInputComponent = <T,>({
  header,
  filterValue,
  filterOperators,
  setFilterMenuAnchor,
}: NumberFilterInputProps<T>) => {
  'use memo';
  const columnId = header.column.id;
  const operator = filterOperators[columnId];

  return (
    <Box sx={filterCellBoxSx}>
      <OperatorIconButton
        columnId={columnId}
        filterOperators={filterOperators}
        filterValue={filterValue}
        onClick={(e) => setFilterMenuAnchor({ element: e.currentTarget, columnId })}
      />

      <Divider orientation="vertical" flexItem sx={filterDividerSx} />

      <input
        className="grid-filter-input"
        type="text"
        value={filterValue}
        onChange={(e) => {
          const op = filterOperators[columnId] ?? '=';
          header.column.setFilterValue(e.target.value ? { op, val: e.target.value } : undefined);
        }}
        placeholder={getOperatorPlaceholder(operator)}
        style={{ ...filterInputBaseStyle, ...filterNativeInputStyle }}
      />
    </Box>
  );
};

export const NumberFilterInput = NumberFilterInputComponent;
